import {
  differenceInCalendarDays,
  differenceInCalendarMonths,
  differenceInCalendarYears,
  differenceInHours,
  differenceInMinutes,
  now
} from "@/utils/date";

export const relativeTime = (v: number, baseTime = now()) => {
  if (!v) return "";
  const m = differenceInMinutes(baseTime, v);
  if (m <= 1 && m >= -1) return "いま";

  const isPast = m > 0;

  if (isPast && m < 60) return `${m}分前`;
  if (!isPast && m > -60) return `${-m}分後`;

  const h = differenceInHours(baseTime, v);
  if (isPast && h < 24) return `${h}時間前`;
  if (!isPast && h > -24) return `${-h}時間後`;

  const d = differenceInCalendarDays(baseTime, v);
  if (isPast && d < 31) return `${d}日前`;
  if (!isPast && d < 31) return `${-d}日後`;

  const month = differenceInCalendarMonths(baseTime, v);
  if (isPast && month < 12) return `${month}ヶ月前`;
  if (!isPast && month < 12) return `${-month}ヶ月後`;

  const year = differenceInCalendarYears(baseTime, v);
  if (isPast) return `${year}年前`;
  return `${-year}年後`;
};
